const roles = {
  ADMIN: 'ROLE_ADMIN',
  MANAGER: 'ROLE_MANAGER',
  USER: 'ROLE_USER',
};

export default {
  roles: roles,
  authenSuccesUrlRedirect: function (hasAuthor) {
    if (hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER)) {
      return '/dashboard.html';
    } else {
      return '/dashboard.html';
    }
  },

  authorizationMapper: [
    {
      regex: /^\/system-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER);
      }
    },
    {
      regex: /^\/user-management\/managed-users/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER);
      }
    },
    {
      regex: /^\/user-management\/managed-position/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER);
      }
    },
    {
      regex: /^\/dashboard.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/user*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER);
      }
    }
  ]
}
